export enum ValidationType {
  None = 1,
  Valid,
  Invalid,
}
